import { DragDropModule } from "@angular/cdk/drag-drop";
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from "@angular/router";
import { UiComponentsModule } from "@shared/ui-components";
import { DashboardModule } from "../dashboard.module";
import { AccessoryTypeDetailComponent } from "./accessory-type-detail/accessory-type-detail.component";
import { AddAccessoryTypeComponent } from "./add-accessory-type/add-accessory-type.component";
import { AddAssetTypeComponent } from './add-asset-type/add-asset-type.component';
import { AssetTypeDetailComponent } from './asset-type-detail/asset-type-detail.component';
import { ManageWorkspaceOwnerComponent } from "./manage-workspace-owner/manage-workspace-owner.component";
import { ProjectSearchComponent } from './project-search/project-search.component';
import { UserDetailsComponent } from "./user-details/user-details.component";
import { UserSearchComponent } from './user-search/user-search.component';
import { VendorSearchComponent } from './vendor-search/vendor-search.component';
import { ClientSearchComponent } from './client-search/client-search.component';
@NgModule({
  declarations: [ManageWorkspaceOwnerComponent, ProjectSearchComponent, UserSearchComponent, AddAssetTypeComponent, AssetTypeDetailComponent, AddAccessoryTypeComponent, AccessoryTypeDetailComponent, UserDetailsComponent, VendorSearchComponent, ClientSearchComponent],
  imports: [UiComponentsModule, DashboardModule, RouterModule, CommonModule, CdkTableModule, FormsModule, ReactiveFormsModule, DragDropModule],
  providers: [],
  exports: [ManageWorkspaceOwnerComponent],
})
export class WorkspaceOwnerModule { }
